import { render, staticRenderFns } from "./LoadingPatient.vue?vue&type=template&id=7336ba42&scoped=true&"
import script from "./LoadingPatient.vue?vue&type=script&lang=js&"
export * from "./LoadingPatient.vue?vue&type=script&lang=js&"
import style0 from "./LoadingPatient.vue?vue&type=style&index=0&id=7336ba42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7336ba42",
  null
  
)

export default component.exports